export default class PostAuctionRequestController {
    constructor() {
        const element = document.querySelector(".js-auction-request");

        if (element) {
            import(
                /* webpackChunkName: "PostAuctionRequest" */ "../classes/PostAuctionRequest"
            ).then(res => {
                const PostAuctionRequest = res.default;
                this.createInstance(PostAuctionRequest, element);
            });
        }
    }

    createInstance(PostAuctionRequest, element) {
        return new PostAuctionRequest(element);
    }
}
